export default "__VITE_ASSET__Ddzo0C50__"